import fp from 'lodash/fp';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, renderComponent } from 'recompose';
import { compose } from 'redux';
import { routes } from '../../../../constants';
import { Icon } from '../../../components';
import Loading from '../../loading';
import { UserSnapshotTable } from './partials/user-snapshot-table';

const TrainingPlanHistory = ({ profile, forBusinessUser }) => {
  const getReportRoute = forBusinessUser ?
    (snapshotId) => routes.app.teams.userSnapshotReport(profile.user.id, snapshotId) :
    (snapshotId) => routes.app.professionalProfile.snapshotProgressReport(snapshotId)
  const description = 'These reports will show a snapshot of your training plan and your progress for the CPD period listed'

  const snapshots = profile.snapshots
  const noHisotry = fp.isEmpty(snapshots)
  return noHisotry ? null :
    <div className='profile--training-plan-history'>
      <Row className='no-gutter'>
        <Col xs={12}>
          <h2>
            <Icon icon='content-large' />{`Training Plan History`}
          </h2>
          <p className='no-margin'>{description}</p>
        </Col>
        <Col xs={12}>
          <UserSnapshotTable user={profile.user} snapshots={profile.snapshots} getReportRoute={getReportRoute} />
        </Col>
      </Row>
    </div>
}

const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ profile }) => !profile,
    renderComponent(Loading)
  )
)(TrainingPlanHistory)


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/training-plan-history.js